import React from 'react';
import { CtaButton } from './CtaButton';
import { problems } from '../data/content';
export function Problems() {
  return <section className="border-b border-line bg-ink-800 py-16 md:py-24" aria-labelledby="problems-title" data-id="element-156" data-mp="36x2dfhfdoztv">
      <div className="mx-auto max-w-4xl px-5 md:px-8" data-id="element-157" data-mp="323hp6h3l7k7v">
        <h2 id="problems-title" className="font-display text-3xl font-extrabold uppercase leading-tight text-white md:text-5xl" data-id="element-158" data-mp="2y3pgm4e71e2i">
          If you coach baseball, you're probably living one of these problems:
        </h2>

        <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-159" data-mp="2o3yhtqilocwm">
          {problems.map(problem => <li key={problem} className="flex gap-3 py-4" data-id="element-160" data-mp="2j89hhkyrarz9">
              <span className="text-accent" aria-hidden="true" data-id="element-161" data-mp="2f5mupygxzx8x">
                ❌
              </span>
              <span className="text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-162" data-mp="hdil4ipnxvaj">{problem}</span>
            </li>)}
        </ul>

        <p className="mt-10 font-display text-3xl font-extrabold uppercase text-accent md:text-4xl" data-id="element-163" data-mp="dbdttqmotar2">
          How many more sessions do you want to keep improvising?
        </p>

        <div className="mt-8" data-id="element-164" data-mp="39r9bi3kq02ii">
          <CtaButton size="md" data-id="element-165" data-mp="2vq6nvme2uk5h">⚾ Stop improvising — unlock the vault for $27</CtaButton>
          <p className="mt-3 text-sm text-slate-400" data-id="element-166" data-mp="2vsjdmlq2tyt3">
            Instant download · Lifetime access · 7-day money-back guarantee
          </p>
        </div>
      </div>
    </section>;
}